import { store } from '../redux/store/store';
import { trimLowerCase } from './shared';

/**** Export functions  ****/
/**
 * Get the help of the fields depending on the tier selected
 * @param {Object} helps
 * @param {Object} tier
 * @param {Object} tierFields
 * @returns
 */
export const setContentFields = (helps, tier, tierFields) => {
  let result = [];

  if (tier?.id) {
    const { actualLanguage } = store.getState().base;
    const categoriesField = tierFields?.filter(elem => (trimLowerCase(
      elem.tier) === trimLowerCase(tier.id)));
    
    const helpsCopy = helps?.map(help => ({ ...help }));
    helpsCopy?.sort((a, b) => a.field - b.field);
    helpsCopy?.forEach((elem, index) => {
      const content = JSON.parse(elem[`content_${trimLowerCase(actualLanguage)}`]);

      const isIndex = categoriesField?.findIndex(item => (
        elem.field === item.field && item.active));

      helpsCopy[index].delete = !(isIndex >= 0);
      helpsCopy[index].text = content?.text;
      helpsCopy[index].html = content?.html;
    });

    result = helpsCopy?.filter(elem => !elem.delete);
  }

  return result;
};